<template>
  <div class="skeleton">
      <transition name="fade" v-if="visibleBoarding">
        <div class="music-onboarding">
          <div class="content">
            <p class="of font-bride">We are engaged!</p>
            <p class="font-host">Dina &amp; Resha</p>
            <hr>
            <p>
              Kepada Yth.<br>
              Bapak/Ibu/Saudara/i
            </p>

            <p class="tamu">
              {{ you }}
            </p>

            <button @click="toggleBoarding">Buka undangan</button>
          </div>
        </div>
      </transition>

      <div :class="['music-button', {'mute': !isPlaying}]" @click="play">
        <img src="../assets/images/della-juan/music.png" alt="">
      </div>

      <div :class="['content-wrapper', {'blur': visibleBoarding}]">
        <section class="header">
          <div class="host text-maroon">
            <p class="of">We are Engaged!</p>
            <img  src="../assets/images/dina-resha/host.png" alt="">
          </div>
        </section>

        <section class="event-detail">
          <div class="desktop-wrapper">
            <p>
              <i>Bismillaahirrahmaanirrahiim</i><br>
              <br>
              <i>Assalaamu'alaikum Warahmatullaahi Wabarakaatuh</i><br>
              <br>
              Maha Suci Allah yang telah menciptakan makhluk-Nya berpasang-pasangan.<br>
              <br>
              Dengan memohon Rahmat dan Ridho Allah SWT, kami sekeluarga mengharap dengan hormat kehadiran Bapak/Ibu/Saudara/i untuk memberikan do’a restu pada acara pertunangan kami:<br>
              <br>
              <br>
              <br>
              <span class="host">Addina Nuzulia Ramadhani, S.Ked.</span><br>
              Putri dari Bapak H. Elvis Chan, S. Pd dan<br>Ibu Hj. Husni Dayati, SH<br>
              <br>
              <span class="host">&amp;</span><br>
              <br>
              <span class="host">Letda CKM drg. Resha Bashofi Alfarichi, MMRS </span><br>
              Putra dari Bapak H. Ahmad Shofiyuddin, S.H. dan<br>Ibu Hj. Siti Aifah<br>
              <br>
              <br>
              <br>
              yang Insya Allah akan dilaksanakan pada:<br><br>
              <span class="dday">
                <img src="../assets/images/dina-resha/flower-left.png" width="22">
                Minggu, 14 Februari 2021
                <img src="../assets/images/dina-resha/flower-right.png" width="22">
              </span><br>
            </p>
            <div class="event">
              <div class="detail">
                <p class="event-time">Pukul 09.00 s.d 13.00 WIB</p>
                <p class="event-venue">
                  di <b>Holiday Inn Cikarang Jababeka</b><br>
                  Jl. Jababeka I No.2, Pasirsari,<br>
                  Cikarang Selatan,<br>
                  Bekasi
                </p>
                <a href="https://www.google.com/maps/dir//holiday+inn+cikarang/@-6.5734935,107.0088016,10z/data=!4m8!4m7!1m0!1m5!1m1!1s0x2e699ad6897190a1:0xf3a42d07bdc62910!2m2!1d107.1454219!2d-6.2945504" target="_blank" class="button"><b>Lihat di peta</b></a>
              </div>
            </div>

            <p>
              Acara ini diselenggarakan dengan tetap menjalankan protokol kesehatan yang harus dipatuhi demi mencegah penyebaran virus Covid-19. Tanpa mengurangi rasa hormat, para tamu undangan dihimbau untuk tetap melakukan 3M:
            </p>
            <div class="aturan-3m">
              <div>
                <img src="../assets/images/dina-resha/mask.png" alt="Memakai masker" width="60">
                <p>Memakai masker</p>
              </div>
              <div>
                <img src="../assets/images/dina-resha/distancing.png" alt="Menjaga jarak" width="60">
                <p>Menjaga jarak</p>
              </div>
              <div>
                <img src="../assets/images/dina-resha/washing hands.png" alt="Mencuci tangan" width="60">
                <p>Mencuci tangan</p>
              </div>
            </div>
            <br>
            <br>

            <p>
              Merupakan suatu kerhormatan dan kebahagiaan bagi kami apabila Bapak / Ibu / Saudara/i, berkenan hadir untuk memberikan doa restu pada acara pertunangan kami.
              <br>
              <br>
              <i>Wassalamu'alaikum Warahmatullahi Wabarakatuh</i>
              <br>
              <br>
              Kami yang berbahagia,
              <br>
              <br>
            </p>
            <div class="family">
              <div class="parent">
                <p>Keluarga</p>
                <p>
                  <span>H. Elvis Chan, S. Pd</span><br>
                  <span>Hj. Husni Dayati, SH</span>
                </p>
              </div>
              <div class="parent">
                <p>Keluarga</p>
                <p>
                  <span>H. Ahmad Shofiyuddin, S.H.</span><br>
                  <span>Hj. Siti Aifah </span>
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="profile ivory-bg">
          <div class="desktop-wrapper">
            <div class="profile-item">
              <div class="photo">
                <p class="photo-name">Addina Nuzulia Ramadhani</p>
                <img src="../assets/images/dina-resha/dina.jpg">
              </div>
              <div class="text">
                <p>
                  You taught me that love is not just about exchanging glances and staring at each other but love is about looking into somebody's soul, sharing the same vision, through different lenses.
                </p>
              </div>
            </div>
            <div class="profile-item">
              <div class="photo">
                <p class="photo-name">Resha Bashofi Alfarichi</p>
                <img src="../assets/images/dina-resha/resha.jpg">
              </div>
              <div class="text">
                <p>
                  If I did anything right in my life, it was when I gave my heart to you, my special one.
                  I believe that God created you for me to love. He picked you out from all the rest cause He knew I’d love you the best.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="gallery ivory-bg">
          <div class="desktop-wrapper">
            <p class="title">Gallery</p>
            <div class="top">
              <img src="../assets/images/dina-resha/gallery1.jpg">
              <img src="../assets/images/dina-resha/gallery2.jpg">
            </div>
            <div class="bottom">
              <img src="../assets/images/dina-resha/gallery3.jpg">
            </div>
          </div>
        </section>

        <section class="greetings ivory-bg">
          <p class="title">Ucapan &amp; do'a</p>
          <div class="desktop-wrapper" v-if="!!formData">
            <carousel :per-page="1" :autoplay="true" :loop="true"
              :paginationEnabled="false" :navigationEnabled="true" :speed="1000"
              :navigationNextLabel="'>'" :navigationPrevLabel="'<'"
            >
              <slide v-for="(data, index) in formData" :key="index">
                <p>{{ data.greeting}}</p>
                <br>
                <p><b>{{ data.name }}</b></p>
              </slide>
            </carousel>
          </div>
        </section>

        <section class="form-greetings ivory-bg">
          <div class="desktop-wrapper">
            <div class="form-input">
              <input type="text" v-model="name" maxlength="30">
              <span>Nama</span>
            </div>
            <div class="form-input">
              <textarea name="greeting" id="" cols="30" maxlength="250" rows="5" v-model="greeting"></textarea>
              <span>Ucapan dan do'a</span>
            </div>
            <p v-if="!formFilled"><i>{{ error }}</i></p>
            <a @click="submitForm"> Kirim ucapan dan do'a</a>
          </div>
        </section>

        <footer class="ivory-bg">
          <p>made with love by <b><a href="http://invity.id" target="_blank">invity.id</a></b> &copy; 2021</p>
        </footer>
      </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: 'dellaJuan',
    data () {
      return {
        visibleBoarding: true,
        isPlaying: false,
        audio : new Audio(require('../assets/sounds/you-are-the-reasons-violin-one.mp3')),
        formData: {},
        name: '',
        greeting:'',
        error: ''
      }
    },
    components: {
      Carousel,
      Slide
    },
    created(){
      document.querySelector('body').style.overflowY = 'hidden'
      this.getFormData()
    },
    computed: {
      you () {
        return this.$route.query.tamu || 'You'
      },
      weddingDate(){
        return moment("2020-11-14T08:00:00").diff(moment(),'milliseconds');
      },
      shift () {
        const jam = this.$route.query.jam || 0
        switch (jam) {
          case '11': return '11.00 - 12.30'
          case '12': return '12.30 - 14.00'
          default: return '11.00 - 14.00'
        }
      },
      formFilled () {
        return this.name.length > 3 && this.greeting.length > 10
      }
    },
    methods: {
      toggleBoarding () {
        this.visibleBoarding = !this.visibleBoarding
        document.querySelector('body').style.overflowY = ''
        this.play()
      },
      play() {
        if(!this.isPlaying){
          this.audio.loop = true;
          this.audio.play();
          this.isPlaying = true;
        } else {
          this.audio.pause()
          this.isPlaying = false;
        }
      },
      submitForm(){
        const result = this.constructData(this.name, this.greeting);    
        const api = 'https://landing-page-ad31d.firebaseio.com/dinaResha.json';

        if (this.formFilled) {
          axios.post(api, result)
          .then(this.successCallback()).catch(function (error) {
            // eslint-disable-next-line no-console
            console.log(error)
          })
          // reset form
          this.error = ''
          this.name = ''
          this.greeting = ''
        } else {
          this.error = 'Pastikan kolom nama dan ucapan sudah terisi ya'
        }
      },
      getFormData(){
        const api = 'https://landing-page-ad31d.firebaseio.com/dinaResha.json';
        axios.get(api).then((response) => {
            this.formData = response.data;
        })
      },
      constructData(name, greeting){
        const currentData = {
            name: name,
            greeting: greeting
        };
        return currentData;
      },
      successCallback(){
        this.$toasted.show("Ucapan dan do'a berhasil di kirim :)").goAway(3000)
        setTimeout(() => { this.getFormData() }, 300)
      }
    }
  }
</script>

<style lang="scss" scoped>

  // FONTS
  @import url('https://fonts.googleapis.com/css2?family=Pontano+Sans&family=Cinzel&display=swap');
  @font-face {
    font-family: 'mango';
    src: url('../fonts/rainbow_universe-webfont.woff2') format('woff2'),
    url('../fonts/rainbow_universe-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }


  // COLORS
  $coksu: #a5837e;
  $cream: #89796c;
  $navy: #484d5a;
  $cokfont:#fff;
  $ivory: #ebebd8;


  // GENERAL STYLING
  p {
    font-family: 'Pontano Sans', sans-serif;
    font-size: .8rem;
    line-height: 1.5;
    letter-spacing: .04rem;
    color: $cokfont;
    margin: 0;
  }

  .skeleton {
    background: $coksu;
    transition: all .3s ease-in-out;
  }
  .desktop-wrapper {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    @media only screen and (max-width: 768px) {
      width: calc(100% - 64px);
      padding: 0 32px;
    }
  }
  .ivory-bg {
    background: $ivory;
    color: $coksu;
    p {
      color: $coksu;
    }
  }


  // SECTION STYLING
  .header {
    width: 100vw;
    height: 100vh;
    background-image: url('../assets/images/dina-resha/header.jpg');
    background-size: cover;
    position: relative;
    background-position: center;
    .host {
      position: absolute;
      width: 70%;
      max-width: 500px;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      .of {
        font-size: 1rem;
        font-weight: 700;
        font-family: 'Cinzel', serif;
        color: $coksu;
        letter-spacing: .1rem;
        margin: 0 0 20px 0;
      }
      img {
        width: 100%;
      }
    }
  }

  .event-detail {
    margin: 80px 0;
    .host {
      font-family: 'Cinzel', serif;
      font-size: 1.5rem;
      @media only screen and (max-width: 768px) {
        font-size: 1rem;
        line-height: 2;
        font-weight: 700;
      }
    }
    .dday {
      font-family: 'Cinzel', serif;
      font-size: 2rem;
      font-weight: 700;
      @media only screen and (max-width: 768px) {
        font-size: 1.1rem;
      }
    }
    .button {
      margin: 12px auto 0;
      font-size: .8rem;
      border: none;
      border-radius: 100px;
      font-family: inherit;
      padding: 12px;
      cursor: pointer;
      background: $ivory;
      color: $coksu;
      text-decoration: none;
      display: block;
      width: 100px;
      font-family: 'Pontano Sans', sans-serif;
    }
    .event {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 70px;
      @media only screen and (max-width: 768px) {
        display: block;
        .detail + .detail {
          margin-top: 40px;
        }
      }
      &-name {
        font-family: 'Cinzel', serif;
        font-size: 1.5rem;
        @media only screen and (max-width: 768px) {
          font-size: 1.3rem;
        }
      }
      &-time {
        margin: 8px 0;
      }
      &-venue {
        line-height: 1.5;
      }
    }
    .family {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .parent {
        display: block;
        p {
          &:nth-of-type(1) {
            margin-right: 8px;
          }
          span:nth-of-type(2) {
            &:before {
              content: '';
              width: 100%;
              height: 1px;
              background: $cokfont;
              display: block;
            }
          }
        }
        @media only screen and (max-width: 400px) {
          p {
            font-size: .7rem;
          }
        }
      }
    }
  }

  .profile {
    position: relative;
    padding: 80px 0;
    &-item {
      display: flex;
      z-index: 1;
      position: relative;
      & + .profile-item {
        margin-top: 60px;
      }
      &:nth-child(2) {
        direction: rtl;
        .photo-title {
          right: auto;
          left: 10px;
        }
        .photo-name {
          left: auto;
          right: -10px;
          bottom: -14px;
        }
        .text {
          direction: ltr;
          padding: 0 16px 0 0;
          text-align: right;
        }
      }
      .photo {
        width: 200px;
        position: relative;
        @media only screen and (max-width: 480px) {
          margin: 0 auto;
        }
        img {
          width: 100%;
          border-radius: 20px;
        }
        &-title {
          font-family: 'mango';
          font-size: 1.6rem;
          position: absolute;
          top: -20px;
          right: 10px;
        }
        &-name {
          font-family: 'Cinzel', serif;
          font-size: 1.2rem;
          position: absolute;
          background: $navy;
          color: ivory;
          border-radius: 100px;
          padding: 6px 16px;
          width: max-content;
          bottom: -14px;
          left: -16px;
        }
      }
      .text {
        width: calc(100% - 200px);
        padding-left: 16px;
        text-align: left;
        @media only screen and (max-width: 480px) {
          width: calc(100% - 64px);
          padding: 0 0 0 16px;
        }
        p {
          line-height: 1.5;
        }
        a {
          font-family: 'Pontano Sans', sans-serif;
          color: $cokfont;
          text-decoration: none;
          display: flex;
          font-size: .9rem;
          img {
            width: 16px;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .gallery {
    .title {
      font-family: 'mango';
      font-size: 2.4rem;
      margin-bottom: 20px;
    }
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        width: calc(50% - 8px);
        border-radius: 20px;
      }
    }
    .bottom {
      img {
        width: 100%;
        border-radius: 20px;
        margin-top: 16px;
      }
    }
  }

  footer {
    padding-bottom: 20px;
    a {
      font-family: 'Pontano Sans', sans-serif;
      color: $coksu;
      text-decoration: none;
    }
  }

  .music-onboarding {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    box-sizing: border-box;
    font-family: 'Pontano Sans', sans-serif;
    font-size: .85rem;
    line-height: 1.5;
    letter-spacing: .04rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      background: $coksu;
      padding: 20px;
      border-radius: 20px;
      box-sizing: content-box;
      width: 100%;
      margin: 20px;
      max-width: 280px;
      width: 100%;
      box-shadow:
        0 2.8px 2.2px rgba(0, 0, 0, 0.034),
        0 6.7px 5.3px rgba(0, 0, 0, 0.048),
        0 12.5px 10px rgba(0, 0, 0, 0.06),
        0 22.3px 17.9px rgba(0, 0, 0, 0.072),
        0 41.8px 33.4px rgba(0, 0, 0, 0.086),
        0 100px 80px rgba(0, 0, 0, 0.12);
      z-index: 1;
      .font-bride {
        font-size: 1rem;
        font-family: 'Cinzel', serif;
      }
      hr {
        background-color: $ivory;
        border-style: none;
        height: 1px;
        opacity: .3;
        margin: 0 0 20px;
      }
      .font-host {
        font-size: 2.5rem;
        font-family: 'mango';
      }
    }
    &:before {
      content: '';
      background:  #ededed;
      position: absolute;
      left: 0;
      top: 0;
      opacity: .7;
      width: 100%;
      height: 100%;
    }
    p {
      z-index: 1;
      position: relative;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      cursor: pointer;
      outline: none;
      &.tamu {
        font-size: 1.5rem;
        margin-top: 20px;
      }
    }
    button {
      z-index: 1;
      position: relative;
      border: none;
      padding: 16px 24px;
      border-radius: 20px;
      margin-top: 20px;
      background: $ivory;
      color: $coksu;
    }
  }

  .content-wrapper {
    &.blur {
      filter: blur(4px);
    }
  }

  .music-button {
    position: fixed;
    right: 0;
    top: 60%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    background: $cokfont;
    border-radius: 100%;
    z-index: 4;
    cursor: pointer;
    opacity: .8;
    img {
      width: 20px;
      position: relative;
      top: 10px;
      left: -2px;
    }
    &.mute {
      &:before {
        content: "";
        width: 30px;
        height: 2px;
        background: $coksu;
        position: absolute;
        transform: rotate(-45deg);
        bottom: 17px;
        right: 4px;
        z-index: 1;
        border: 1px solid $cokfont;
        opacity: .7;
      }
    }
    @media only screen and (max-width: 768px) {
      right: -16px;
    }
  }

  .greetings {
    padding: 70px 32px 20px;
    .title {
      font-family: 'mango';
      font-size: 2.4rem;
      margin-bottom: 20px;
    }
    ::v-deep .VueCarousel-navigation-button {
      background: $coksu;
      color: $ivory;
      border-radius: 100px;
      width: 30px;
      height: 30px;
      padding: 5px !important;
      font-weight: 600;
    }
  }

  .form-greetings {
    padding: 24px 0 80px;
    .form-input {
      position: relative;
      margin-top: 24px;
      span {
        position: absolute;
        top: 4px;
        left: 49px;
        font-family: 'Pontano Sans', sans-serif;
        font-size: .7rem;
        letter-spacing: .04rem;
      }
    }
    input {
      width: calc(100% - 64px);
      height: 40px;
      padding: 16px 16px 9px;
      box-sizing: border-box;
      background: transparent;
      border: 1px solid $coksu;
      border-radius: 16px;
      color: $coksu;
      &:focus, &:active {
        outline: none;
      }
    }
    textarea {
      font-family: 'Pontano Sans', sans-serif;
      font-size: .85rem;
      line-height: 1.5;
      letter-spacing: .04rem;
      width: calc(100% - 64px);
      margin: 0 32px;
      padding: 16px;
      box-sizing: border-box;
      background: transparent;
      border: 1px solid $coksu;
      border-radius: 16px;
      color: $coksu;
      &:focus, &:active {
        outline: none;
      }
    }
    a {
      margin: 12px auto 0;
      font-size: .8rem;
      border: none;
      border-radius: 100px;
      font-family: inherit;
      padding: 12px;
      cursor: pointer;
      background: $coksu;
      color: $ivory;
      text-decoration: none;
      display: block;
      width: 150px;
      font-family: 'Pontano Sans', sans-serif;
    }
  }

  .aturan-3m {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
  }
</style>
